<template>
  <authenticated-layout :back-route="{ name: 'institutionDashboard', params: { institutionId, tab: 'licenses' } }"
                        :breadcrumbs="breadcrumbItems">

    <AccessCodeDetailContent
      @access-code-loaded="onAccessCodeLoaded"
    />
  </authenticated-layout>
</template>

<script setup lang="ts">
import {onMounted, ref, computed} from "vue";
import {AccessCode, Institution} from "@YenzaCT/sdk";
import AuthenticatedLayout from "@/layout/AuthenticatedLayout.vue";
import AccessCodeDetailContent from "@/components/AccessCodeDetail/AccessCodeDetailContent.vue";

import yapi from "@/lib/yapi";
import {useApiCall} from "@/composables/useApiCall";
import {useRoute} from "vue-router";
import {useGlobalStore} from "@/store";

const route = useRoute();
const { executeApi } = useApiCall();

const institutionId = route.params.institutionId as string;
const store = useGlobalStore();

const accessCode = ref<AccessCode>();
const institution = ref<Institution>();
const canAccessSpecificTenant = store.canAccessSpecificTenant(route.params.tenantId as string);

const breadcrumbItems = computed(() => [
  { text: "My Schools", to: { name: "schoolsDashboard" } },
  { text: institution.value?.tenantMeta?.title || "",
    to: canAccessSpecificTenant ? { name: "schoolsDashboardWithTenant",
      params: { tenantId: institution.value?.tenant } } : {
      name: "schoolsDashboardWithoutTenant"
    }},
  {
    text: institution.value?.title || "Institution",
    to: { name: "institutionDashboard", params: { institutionId } }
  },
  { text: accessCode.value?.code ? `License #${accessCode.value.code}` : "License Details" }
]);

async function fetchInstitution() {
  const result = await executeApi(async () => {
    const response = await yapi.admin.institution.get(institutionId);
    return response.data;
  });
  if (result) {
    institution.value = result;
  }
}

function onAccessCodeLoaded(loadedAccessCode: AccessCode) {
  accessCode.value = loadedAccessCode;
}

onMounted(async () => {
  await fetchInstitution();
});
</script>
